export default __webpack_public_path__ + "static/media/team_khaled.e1d29300.jpg";